export default __webpack_public_path__ + "static/media/PastaSauce.08f04510.jpg";